import { render, staticRenderFns } from "./QuestionNode.vue?vue&type=template&id=9f2f0846&scoped=true&"
import script from "./QuestionNode.vue?vue&type=script&lang=js&"
export * from "./QuestionNode.vue?vue&type=script&lang=js&"
import style0 from "./QuestionNode.vue?vue&type=style&index=0&id=9f2f0846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2f0846",
  null
  
)

export default component.exports